/* Amaxa — About page. Лише ініціалізація Lucide-іконок. */
(function(){
  function boot(){ if(window.lucide) lucide.createIcons(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
